import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { SearchResponse } from '@/api/search';

interface DebugPanelProps {
  searchResponse: SearchResponse | null;
  isVisible?: boolean;
}

export function DebugPanel({ searchResponse, isVisible = false }: DebugPanelProps) {
  if (!isVisible || !searchResponse) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Debug: JSON Response</CardTitle>
        <CardDescription>
          Отладочная информация - JSON ответ от API
        </CardDescription>
      </CardHeader>
      <CardContent>
        <pre className="bg-muted p-4 rounded-md text-sm overflow-auto max-h-96">
          {JSON.stringify(searchResponse, null, 2)}
        </pre>
      </CardContent>
    </Card>
  );
}
